import { useState } from 'react';
import './SignUpPage.css' 
import { Link, useNavigate } from 'react-router-dom'; 
import axios from 'axios';

let SignUpPage = (props) => {
// ---------------------------------------------------------------------------
    // This is the shortest method to get all input name value pair

    // let [inputs, setunputs]=useState({});
    //     let inputchangehandler=(e)=>{
    //         let name = e.target.name; 
    //         let value = e.target.value;
    //         setunputs(values =>({...values, [name]: value}));
            
    //     }
    
// ----------------------------------------------------------------------------
    const navigate = useNavigate();
    let [username, setEnterName] = useState(''); 
    let [fullName, setfullName] = useState('');
    let [fathername, setFatherName] = useState('');
    let [mothername, setMotherName] = useState('');
    let [dob, setdob] = useState('');
    let [email, setEmailId] = useState('');
    let [password, setPassword] = useState('');
    let [ConfPassword, setConfPassword] = useState('');
    let [msg, setmsg] =useState("");
    let [avatar, setavatar] = useState(null)

    

    let formsubmithandler = async(event)=>{
        event.preventDefault();

       if(username === ""){
            props.Successandrerrorfun("", "UserName is Empty");
            return null;
        }else if(fullName === ""){
            props.Successandrerrorfun("", "FullName is Empty");
            return null;
        }else if(fathername === ""){
            props.Successandrerrorfun("", "FatherName is Empty");
            return null;
        }else if(mothername === ""){
            props.Successandrerrorfun("","MotherName is Empty")
            
            return null;
        }else if(dob === ""){
            props.Successandrerrorfun( "", "Please Enter Date of Birth")
            
            return null;
        }else if(avatar === null){
            props.Successandrerrorfun( "", "Please Select Photo")
            
            return null;
        }
else if(password !== ConfPassword){
            props.Successandrerrorfun("","password not matched")
             
            return null;
            
        }else if(password.length < 8){
            props.Successandrerrorfun("","Password min 8 char.")
            return null;
        }



        const fromdata = new FormData();

        fromdata.append('email', email)
        fromdata.append('username', username)
        fromdata.append('fullName', fullName)
        fromdata.append('fathername', fathername)
        fromdata.append('mothername', mothername)
        fromdata.append('avatar', avatar)
        fromdata.append('dob', dob)
        fromdata.append('password', password)
      
        let SignupData = {
            email : email,
            username : username,
            fullName: fullName,
            fathername : fathername,
            mothername : mothername,
            avatar : avatar,
            dob : dob,
            password : password,
            confirmpass: ConfPassword
        }

       try {
         const reaponse =  await axios.post("https://makeeasyway.in/resumeData/ResumeSignup.php", fromdata).then(res=>{
            if(res.data.result=== "Email already exist..!"){
            props.Successandrerrorfun("",res.data.result);
            
                

            } else{
            props.Successandrerrorfun(res.data.result, "");
             setEnterName('');
            setdob('');
            setFatherName('');
            setEmailId('');
            setPassword('');
            setConfPassword('');
            setMotherName('')
            setavatar(null);

            }
               
             
         }).catch((error)=>{
             console.log(error) 
         })
       } catch (error) {
        console.log(error)
       }
         
    
       

        
    }

    return(  
        <div className='signup_cont'> 
            <div className='left_side'> 
                <p className='hellomsg'>Hello!</p>
                <p className='showerrmsg' style={{display:"inline"}}>{msg}</p>
            </div>
            <div className='right_side'>
                <h2 className='signup_heading'>Registration Form</h2> 
                <form onSubmit={formsubmithandler} className='form_cont'>

                    <input className='form_inputs' type='text' value={username} name='UserName' onChange={(event)=>setEnterName(event.target.value)}  placeholder='User Name'/>
        
                    <input className='form_inputs' type='text' value={fullName} name='fullName' onChange={(event)=>setfullName(event.target.value)}  placeholder='Full name'/>

                    <input className='form_inputs' value={email} required type='text' name='EmailID' onChange={(event)=>setEmailId(event.target.value)} placeholder='EMAIL' />


                    <input className='form_inputs' type='date' value={dob} name='dob' onChange={(event)=>setdob(event.target.value)}  placeholder='Date Of Birth'/> 

                    <label style={{display:"flex", justifyContent:"center", alignItems:"center", boxShadow: "0px 0px 5px 1px black", border:"1px solid blue", cursor:"pointer"}} className='form_inputs' htmlFor='file'>Choose Photo</label>
                    <input onChange={(event)=>setavatar(event.target.files[0])} style={{display: "none"}} type='file' id='file' className='form_inputs'/>


                    <input className='form_inputs' type='text' value={fathername} name='FatherName' onChange={(event)=>setFatherName(event.target.value)}  placeholder='Father Name'/>
                    
                    <input className='form_inputs' type='text' value={mothername} name='mothername' onChange={(event)=>setMotherName(event.target.value)}  placeholder='mother Name'/>

                    <input autoComplete='false' className='form_inputs'  value={password} type='password' name='pass' onChange={(event)=>setPassword(event.target.value)} placeholder='Password' />


                    <input autoComplete='false' className='form_inputs'  value={ConfPassword} type='password' name='confirmpass' onChange={(event)=>setConfPassword(event.target.value)}  placeholder='Confirmpassword'/>


                    <input type='submit' name='submit' value="Register" className='form_submitbtn'/>
                    <p>
                        If Already registered ! <Link style={{ backgroundColor:"blue" , color:"white", padding:"3px"}} to='.././LoginPage'>LogIn</Link>
                    </p>
                </form>
            </div>
        </div>
    );

}
export default SignUpPage;